












































import { LeadService } from "@/services/lead.service";
import DatePickerCalendar from "@/shared/components/date-picker-calendar.vue";
import Modal from "@/shared/components/modal.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { required } from "@/shared/validators";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import ComboMotivoLead from "../components/ComboMotivoLead.vue";

@Component({
  components: { Modal, ComboMotivoLead, DatePickerCalendar },
})
export default class ReagendarAtendimento extends mixins(GlobalMixin) {
  loading = false;
  observacao: string | null = null;
  hora: string | null = null;
  data: string | null = null;
  idLead: number | null = null;

  rules = {
    data: [required()],
    hora: [required()],
    observacao: [required()],
  };

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async reagendarAtendimento(idLead: number) {
    this.idLead = idLead;
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    return p;
  }

  async reagendar() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      try {
        if (this.idLead) {
          await LeadService.reagendarAtendimento(
            this.idLead,
            this.data!,
            this.hora!,
            this.observacao
          );
        }
        return modal.close(true);
      } finally {
        this.loading = false;
      }
    }
  }
}
